import{gql as t}from"@apollo/client";const o=t`
  mutation endContentPageCompletion($contentPageCompletionId: Int!) {
    userFlowStepTrack {
      endContentPageCompletion(trackingId: $contentPageCompletionId, status: COMPLETED) {
        id
      }
    }
  }
`;export{o as END_CONTENT_PAGE_COMPLETION_MUTATION};
//# sourceMappingURL=useEndContentPageCompletion.graphql.js.map
